import { Chip, Paper, Stack, Tooltip, Typography } from '@mui/material'
import { NOME_CREDENCIAL, type GrupoCredencial, type SituacaoCredenciais } from '../api/admin'

const ORDEM: GrupoCredencial[] = ['meta', 'google_ads', 'google_organico', 'ia', 'email']

/** Quais credenciais estão configuradas nos secrets do Supabase (e em Configurações → IA). */
export function CredenciaisCard({ s, gerencia = true }: { s: SituacaoCredenciais; gerencia?: boolean }) {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, fontFamily: '"Outfit", sans-serif' }}>
        Credenciais
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.25 }}>
        {gerencia
          ? 'O ID de cada conta diz o que coletar; a credencial diz quem acessa. Elas ficam nos secrets do Supabase (Edge Functions → Secrets) — veja docs/ACESSOS.md.'
          : 'O acesso do MarketingHUB a cada plataforma. Se alguma estiver faltando, fale com o administrador.'}
      </Typography>
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        {ORDEM.map((g) => {
          const c = s[g]
          const dica = c.ok ? (c.observacao ?? 'Configurada') : `Falta: ${c.falta.join(', ')}`
          return (
            <Tooltip key={g} title={dica}>
              <Chip
                variant="outlined"
                color={c.ok ? (c.observacao && g === 'google_ads' ? 'warning' : 'success') : 'default'}
                label={`${NOME_CREDENCIAL[g]}: ${c.ok ? 'configurada' : 'falta'}`}
              />
            </Tooltip>
          )
        })}
      </Stack>
    </Paper>
  )
}
